import { UseDIRProspectsResponse } from '../../../../hooks/fetchers/useDIRProspects/useDIRProspects.types';
import { UseProspectsResponse } from '../../../../hooks/fetchers/useProspects/useProspects.types';
import { PageQueryParams } from '../../api.types';

export type Prospect = {
  id: number;
  id_commercial: number;
  id_user: number;
  name_company: string;
  name: string;
  email: string;
  phone: string;
  status: ProspectStatus;
  reminder_date?: Date;
  created_at: Date;
};

export enum ProspectStatus {
  Gagné = 'gagné',
  Perdu = 'perdu',
  AContacter = 'à contacter',
  Reflexion = 'en cours de réflexion',
  AdhésionEnCours = 'adhésion en cours',
  Relancer = 'à relancer',
  Presentation = 'présentation direction',
  Deleting = 'en attente de suppression',
}

export type ProspectStatusHistory = {
  id: number;
  id_prospect: number;
  status: string;
  comment: string;
  created_at: Date;
}

export type SearchProspectsFromCOMResponse = UseProspectsResponse;

export type SearchProspectsFromDIRResponse = UseDIRProspectsResponse;

export interface GetProspectsFromDIRQueryParams extends PageQueryParams {
  commercialIds?: string[];
}

export interface UpdateStatusProspectWithCommentRequestData {
  id: number;
  email: string;
  status: string;
  comment: string;
  reminder_date?: string;
}
